import React, { useState } from "react";
import Headers from "../components/Headers";
import Footer from "../components/Footer";
import { Link, Outlet, useNavigate } from "react-router-dom";
import { FaCalendarAlt, FaList } from "react-icons/fa";
import { RxDashboard } from "react-icons/rx";
import { RiLogoutCircleLine } from "react-icons/ri";
import { IoIosApps } from "react-icons/io";
import { BsChat, BsHeart } from "react-icons/bs";
import { TfiLock } from "react-icons/tfi";
import { IoDocumentsOutline } from "react-icons/io5";
import api from "../api/api";
import { useDispatch } from "react-redux";
import { user_reset } from "../store/reducers/authReducer";
import { reset_count } from "../store/reducers/cardReducer";
import { MdMenuOpen, MdAddCard } from "react-icons/md";

const Dashboard = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [filterShow, setFilterShow] = useState(false);

  const logout = async () => {
    try {
      const { data } = await api.get("/customer/logout");
      localStorage.removeItem("customerToken");
      dispatch(user_reset());
      dispatch(reset_count());
      navigate("/login");
    } catch (error) {
      console.log(error.response.data);
    }
  };
  return (
    <div>
      <Headers />
      <div className="bg-slate-200 py-10 ">
        <div className="w-[90%] mx-auto pt-5 md-lg:block hidden">
          <div>
            <button
              onClick={() => setFilterShow(!filterShow)}
              className="text-center px-1 text-[30px] text-cyan-500"
            >
              <MdMenuOpen />
            </button>
          </div>
        </div>
        <div className="h-full mx-auto">
          <div className="py-5 flex md-lg:w-[90%] mx-auto relative">
            <div
              className={` rounded-xl z-20 md-lg:absolute ${
                filterShow ? "-left-4" : "-left-[360px]"
              } w-[270px] ml-4 sm:ml-0 sm:rounded-r-xl sm:rounded-l-none bg-mainBg/80 backdrop-blur-md shadow-lg shadow-slate-700/10`}
            >
              <ul className="py-2 text-slate-600 px-4">
                <li className="flex justify-start items-center gap-2 py-2 hover:text-[#fb00ea] border-b-2">
                  <span className="text-xl">
                    <RxDashboard />
                  </span>
                  <Link to="/dashboard" className="text-sm">
                    Dashboard - الرئيسية
                  </Link>
                </li>
                <li className="flex justify-start items-center gap-2 py-2 hover:text-[#fb00ea] border-b-2">
                  <span className="text-xl">
                    <FaCalendarAlt />
                  </span>
                  <Link to="/dashboard/my-appointments" className="text-sm">
                    Rendez-vous - المواعيد
                  </Link>
                </li>
                <li className="flex justify-start items-center gap-2 py-2 hover:text-[#fb00ea] border-b-2">
                  <span className="text-xl">
                    <IoDocumentsOutline />
                  </span>
                  <Link to="/dashboard/medical-files" className="text-sm">
                    Dossiers méd - الملفات الطبية
                  </Link>
                </li>
                <li className="flex justify-start items-center gap-2 py-2 hover:text-[#fb00ea] border-b-2">
                  <span className="text-xl">
                    <IoIosApps />
                  </span>
                  <Link to="/dashboard/my-orders" className="text-sm">
                    Commandes - طلبات
                  </Link>
                </li>

                <li className="flex justify-start items-center gap-2 py-2 hover:text-[#fb00ea] border-b-2">
                  <span className="text-xl">
                    <BsHeart />
                  </span>
                  <Link to="/dashboard/my-wishlist" className="text-sm">
                    Wishlist - قائمة الرغبات
                  </Link>
                </li>
                <li className="flex justify-start items-center gap-2 py-2 hover:text-[#fb00ea] border-b-2">
                  <span className="text-xl">
                    <BsChat />
                  </span>
                  <Link to="/dashboard/chat" className="text-sm">
                    Chat - محادثات
                  </Link>
                </li>
                <li className="flex justify-start items-center gap-2 py-2 hover:text-[#fb00ea] border-b-2">
                  <span className="text-xl">
                    <MdAddCard />
                  </span>
                  <Link to="/dashboard/subscription" className="text-sm">
                    Abonnement - الاشتراك
                  </Link>
                </li>

                <li className="flex justify-start items-center gap-2 py-2 hover:text-[#fb00ea] border-b-2">
                  <span className="text-xl">
                    <TfiLock />
                  </span>
                  <Link to="/dashboard/chage-password" className="text-sm">
                    Changer le MDP
                  </Link>
                </li>
                <li
                  onClick={logout}
                  className="flex justify-start items-center gap-2 py-2 cursor-pointer hover:text-[#fb002e] "
                >
                  <span className="text-xl">
                    <RiLogoutCircleLine />
                  </span>
                  <div className="block">Déconnexion - الخروج</div>
                </li>
              </ul>
            </div>
            <div className="w-[calc(100%-270px)] md-lg:w-full">
              <div className="mx-4 md-lg:mx-0">
                <Outlet />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Dashboard;
